import _ from "lodash";
import moment from "moment";

export const KIND_ENDORSEMENTS = {
  CANCELAMENTO: "cancelamento",
  ALTERACAO: "alteracao",
};
export const endorsementOptions = {
  [KIND_ENDORSEMENTS.CANCELAMENTO]: {
    title: "Cancelamento",
    action: "setShowEndossoCancelamentoDialog",
  },
  [KIND_ENDORSEMENTS.ALTERACAO]: {
    title: "Alteração de Vigência e/ou IS",
    action: "goToForm",
  },
};

export const KIND_DOWNLOAD_ENDORSEMENTS = {
  APOLICE: "apolice",
  BOLETO: "boleto",
};
export const downloadEndorsementOptions = {
  [KIND_DOWNLOAD_ENDORSEMENTS.APOLICE]: {
    title: "Apólice",
    action: "getMinuta",
  },
  [KIND_DOWNLOAD_ENDORSEMENTS.BOLETO]: { title: "Boleto", action: "getBoleto" },
};

/**
 * For any item in the 'table' of valid items for endorse an policy
 * the sum/&& of all values must be true.
 * @see test/unit/endorsement_lib.spec.js
 */
export const canEndorse = (policy, kind) => {
  let validacoes = policy.validacoes || {};
  !_.has(policy, "validacoes") &&
    console.warn("Proposal doesn't have key 'validacoes'.");
  return (
    !_.isEmpty(validacoes) &&
    _.every(
      Object.values(
        _.omitBy(
          validacoes,
          (value, key) =>
            (kind === "cancelamento" && key === "tomador_ccg_formalizado") ||
            key === "tomador_ccg_formalizado"
        )
      )
    )
  );
};

// Validations for endorsement.

// * Validate change of "Importancia Segurada"

export const isISValueChanged = (policy, valor) =>
  policy.coberturas[0].importancia_segurada !== valor;

export const validateISValue = (policy, { valor }) =>
  Boolean(valor) && isISValueChanged(policy, valor);

export const vigencyMustStartAfterCurrent = (policy, inicio_vigencia) =>
  inicio_vigencia.isAfter(moment(policy.inicio_vigencia));

export const validateISDate = (policy, { inicio_vigencia }) =>
  Boolean(inicio_vigencia) &&
  vigencyMustStartAfterCurrent(policy, inicio_vigencia);

export const validateISChanged = (policy, updatedIS) =>
  validateISValue(policy, updatedIS) && validateISDate(policy, updatedIS);

// * Validate change of "Vigência".

export const validateVigencyAtLeastCurrent = (
  { coberturas },
  { inicio_vigencia }
) =>
  inicio_vigencia &&
  inicio_vigencia.isSameOrAfter(moment(coberturas[0].inicio_vigencia));

export const validateVigencyDate = (u, { inicio_vigencia, fim_vigencia }) =>
  Boolean(fim_vigencia) && fim_vigencia.isAfter(inicio_vigencia);

export const validateAfterDate = (start, end) =>
  Boolean(end) && end.isAfter(start);

export const validateVigencyChange = (policy, updatedVigency) =>
  validateVigencyAtLeastCurrent(policy, updatedVigency) &&
  validateAfterDate(
    updatedVigency.inicio_vigencia_apolice,
    updatedVigency.fim_vigencia
  );

export const validateObjetoTags = (policy) =>
  policy.objeto_tags.every((tag) => Boolean(tag.value));

export const validateISGreaterThanApoliceIS = (policy, valor) =>
  policy.coberturas[0].importancia_segurada < valor;

export const validateVigencyEndDateGreaterThanCurrentApolice = (
  { coberturas },
  fim_vigencia
) => {
  const policy_vigency_end = coberturas[0].fim_vigencia;
  return fim_vigencia.isSameOrAfter(policy_vigency_end);
};



// WEBPACK FOOTER //
// ./src/libs/endorsement.js